// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    LoaderPinwheel,
    Locate,
    LocateFixed,
    LocateOff,
    Lock,
    LockKeyhole,
    LockKeyholeOpen,
    LockOpen,
    LogIn,
    LogOut,
    Logs,
    Lollipop,
    Luggage,
    Magnet,
    Mail,
    MailBadge,
    MailCheck,
    MailClock,
    MailMinus,
    MailOpen,
    MailPen,
    MailPlus,
    MailQuestionMark,
    MailSearch,
    MailWarning,
    MailX,
    Mailbox,
    Mails,
    Map,
    MapMinus,
    MapPin,
    MapPinCheck,
    MapPinCheckInside,
    MapPinHouse,
    MapPinMinus,
    MapPinMinusInside,
    MapPinOff,
    MapPinPen,
    MapPinPlus,
    MapPinPlusInside,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "loader-pinwheel" through "map-pin-plus-inside", inclusive. */
const shard: Record<string, LucideIcon> = {
    "loader-pinwheel": LoaderPinwheel,
    locate: Locate,
    "locate-fixed": LocateFixed,
    "locate-off": LocateOff,
    lock: Lock,
    "lock-keyhole": LockKeyhole,
    "lock-keyhole-open": LockKeyholeOpen,
    "lock-open": LockOpen,
    "log-in": LogIn,
    "log-out": LogOut,
    logs: Logs,
    lollipop: Lollipop,
    luggage: Luggage,
    magnet: Magnet,
    mail: Mail,
    "mail-badge": MailBadge,
    "mail-check": MailCheck,
    "mail-clock": MailClock,
    "mail-minus": MailMinus,
    "mail-open": MailOpen,
    "mail-pen": MailPen,
    "mail-plus": MailPlus,
    "mail-question-mark": MailQuestionMark,
    "mail-search": MailSearch,
    "mail-warning": MailWarning,
    "mail-x": MailX,
    mailbox: Mailbox,
    mails: Mails,
    map: Map,
    "map-minus": MapMinus,
    "map-pin": MapPin,
    "map-pin-check": MapPinCheck,
    "map-pin-check-inside": MapPinCheckInside,
    "map-pin-house": MapPinHouse,
    "map-pin-minus": MapPinMinus,
    "map-pin-minus-inside": MapPinMinusInside,
    "map-pin-off": MapPinOff,
    "map-pin-pen": MapPinPen,
    "map-pin-plus": MapPinPlus,
    "map-pin-plus-inside": MapPinPlusInside,
};

export default shard;
